(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ad-look-only-image-men"] && !window.DesignMode) return;
  try {
    
jQuery('.slider-images-look-only-image-men').slick({
    dots: false,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: 'linear'
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ad-look-only-image-women"] && !window.DesignMode) return;
  try {
    
jQuery('.slider-images-look-only-image-women').slick({
    dots: false,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: 'linear'
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ad-looks-only-image"] && !window.DesignMode) return;
  try {
    

jQuery('.slider-images-look').slick({
    dots: false,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: 'linear'
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ad-page-video-listing"]) return;
  try {
    
    var player = plyr.setup('.player-video');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ad-shop-the-look-men"]) return;
  try {
    
// Init master slider
jQuery('#shopify-section-ad-shop-the-look-men .master-slider-look').slick({
  dots: false,
  infinite: true,
  speed: 800,
  fade: true,
  cssEase: 'linear',
  draggable: false,
  swipe: false,
  swipeToSlide: false,
  touchMove: false,
  adaptiveHeight: true,
  arrows: false
});

// Click prev arrow master slider
$('.prev-master-slider').click(function(){
  $('#shopify-section-ad-shop-the-look-men .master-slider-look').slick('slickPrev');
});
// Click next arrow master slider
$('.next-master-slider').click(function(){
  $('#shopify-section-ad-shop-the-look-men .master-slider-look').slick('slickNext');
});


/*
// Init slider image look
jQuery('#shopify-section-ad-shop-the-look-men .slider-collections').slick({
    dots: false,
    infinite: true,
    speed: 800,
    fade: true,
    cssEase: 'linear',
    draggable: false,
    swipe: false,
    swipeToSlide: false,
    touchMove: false,
    adaptiveHeight: false,
    arrows: false
});
*/

/*
// Click prev arrow collections slider
$('.prev-collections-slider').click(function(){
  $('#shopify-section-ad-shop-the-look-men .slider-collections').slick('slickPrev');
})
// Click next arrow collections slider
$('.next-collections-slider').click(function(){
  $('#shopify-section-ad-shop-the-look-men .slider-collections').slick('slickNext');
})
*/

// Collection handle from url
var collection_handle = getUrlVars()["look"] || null;
// console.log('collection_handle', collection_handle);
if (collection_handle != null) {
  // Get item index slide
  var item_slide = $('.master-slider-look div[data-collection="'+collection_handle+'"]');
  var slick_slide_index = 0;
  // var slick_slide_index_parent = 0;
  if (item_slide.length > 0) {
    slick_slide_index = item_slide.data('slick-index');
    // slick_slide_index_parent = item_slide.parent().parent().parent().parent().parent().parent().attr('data-slick-index');
    // console.log('slick_slide_index_parent', slick_slide_index_parent);
  }
  // console.log('slide item index', slick_slide_index);

  // console.log('slick slide parent', slick_slide_index_parent);
  // Go to slide parent by index
  setTimeout(function () {
    $('#shopify-section-ad-shop-the-look-men .master-slider-look').slick("slickGoTo", parseInt(slick_slide_index));
  }, 500);
  // Go to slide child by index
  // $('#shopify-section-ad-shop-the-look-men .slider-collections').slick("slickGoTo", parseInt(slick_slide_index));
}


function getUrlVars() {
  var vars = {};
  var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi,
  function(m,key,value) {
    vars[key] = value;
  });
  return vars;
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ad-shop-the-look-women"]) return;
  try {
    
// Init master slider
jQuery('#shopify-section-ad-shop-the-look-women .master-slider-look').slick({
  dots: false,
  infinite: true,
  speed: 800,
  fade: true,
  cssEase: 'linear',
  draggable: false,
  swipe: false,
  swipeToSlide: false,
  touchMove: false,
  adaptiveHeight: true,
  arrows: false
});

// Click prev arrow master slider
$('.prev-master-slider').click(function(){
  $('#shopify-section-ad-shop-the-look-women .master-slider-look').slick('slickPrev');
});
// Click next arrow master slider
$('.next-master-slider').click(function(){
  $('#shopify-section-ad-shop-the-look-women .master-slider-look').slick('slickNext');
});


/*
// Init slider image look
jQuery('#shopify-section-ad-shop-the-look-women .slider-collections').slick({
    dots: false,
    infinite: true,
    speed: 800,
    fade: true,
    cssEase: 'linear',
    draggable: false,
    swipe: false,
    swipeToSlide: false,
    touchMove: false,
    adaptiveHeight: false,
    arrows: false
});
*/

/*
// Click prev arrow collections slider
$('.prev-collections-slider').click(function(){
  $('#shopify-section-ad-shop-the-look-women .slider-collections').slick('slickPrev');
})
// Click next arrow collections slider
$('.next-collections-slider').click(function(){
  $('#shopify-section-ad-shop-the-look-women .slider-collections').slick('slickNext');
})
*/

// Collection handle from url
var collection_handle = getUrlVars()["look"] || null;
// console.log('collection_handle', collection_handle);
if (collection_handle != null) {
  // Get item index slide
  var item_slide = $('.master-slider-look div[data-collection="'+collection_handle+'"]');
  var slick_slide_index = 0;
  // var slick_slide_index_parent = 0;
  if (item_slide.length > 0) {
    slick_slide_index = item_slide.data('slick-index');
    // slick_slide_index_parent = item_slide.parent().parent().parent().parent().parent().parent().attr('data-slick-index');
    // console.log('slick_slide_index_parent', slick_slide_index_parent);
  }
  console.log('slide item index', slick_slide_index);

  // console.log('slick slide parent', slick_slide_index_parent);
  // Go to slide parent by index
  setTimeout(function () {
    $('#shopify-section-ad-shop-the-look-women .master-slider-look').slick("slickGoTo", parseInt(slick_slide_index));
  }, 500);
  // Go to slide child by index
  // $('#shopify-section-ad-shop-the-look-women .slider-collections').slick("slickGoTo", parseInt(slick_slide_index));
}


function getUrlVars() {
  var vars = {};
  var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi,
  function(m,key,value) {
    vars[key] = value;
  });
  return vars;
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ad-shop-the-look"]) return;
  try {
        
// Init master slider
jQuery('#shopify-section-ad-shop-the-look .master-slider-look').slick({
  dots: false,
  infinite: true,
  speed: 800,
  fade: true,
  cssEase: 'linear',
  draggable: false,
  swipe: false,
  swipeToSlide: false,
  touchMove: false,
  adaptiveHeight: false,
  arrows: false  
});

// Click prev arrow master slider
$('.prev-master-slider').click(function(){
  $('#shopify-section-ad-shop-the-look .master-slider-look').slick('slickPrev');
});
// Click next arrow master slider
$('.next-master-slider').click(function(){
  $('#shopify-section-ad-shop-the-look .master-slider-look').slick('slickNext');
});


// Init slider image look
jQuery('#shopify-section-ad-shop-the-look .slider-collections').slick({
    dots: false,
    infinite: true,
    speed: 800,
    fade: true,
    cssEase: 'linear',
    draggable: false,
    swipe: false,
    swipeToSlide: false,
    touchMove: false,
    adaptiveHeight: false,
    arrows: false
});

/*
// Click prev arrow collections slider
$('.prev-collections-slider').click(function(){
  $('#shopify-section-ad-shop-the-look .slider-collections').slick('slickPrev');
})
// Click next arrow collections slider
$('.next-collections-slider').click(function(){
  $('#shopify-section-ad-shop-the-look .slider-collections').slick('slickNext');
})
*/


// Collection handle from url
var collection_handle = getUrlVars()["look"] || null;
// console.log('collection_handle', collection_handle);
if (collection_handle != null) {
  // Get item index slide
  var item_slide = $('.slider-collections div[data-collection="'+collection_handle+'"]');
  var slick_slide_index = 0;
  var slick_slide_index_parent = 0;
  if (item_slide.length > 0) {
    slick_slide_index = item_slide.data('slick-index');
    // console.log('slide item index', slick_slide_index);
    slick_slide_index_parent = item_slide.parent().parent().parent().parent().parent().parent().attr('data-slick-index');
    // console.log('slick_slide_index_parent', slick_slide_index_parent);
  }
  
  // console.log('slick slide parent', slick_slide_index_parent);
  // Go to slide parent by index
  $('#shopify-section-ad-shop-the-look .master-slider-look').slick("slickGoTo", parseInt(slick_slide_index_parent));  
  // Go to slide child by index
  $('#shopify-section-ad-shop-the-look .slider-collections').slick("slickGoTo", parseInt(slick_slide_index));  
}

function getUrlVars() {
  var vars = {};
  var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi,    
  function(m,key,value) {
    vars[key] = value;
  });
  return vars;
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ad-shop-the-looks-fw"]) return;
  try {
    
jQuery(function ($) {

// Init master slider
jQuery('.master-slider-look').slick({
dots: false,
infinite: true,
speed: 800,
fade: true,
cssEase: 'linear',
draggable: false,
swipe: false,
swipeToSlide: false,
touchMove: false,
adaptiveHeight: true,
arrows: false
});

// Click prev arrow master slider
$('.prev-master-slider').click(function(){
$('.master-slider-look').slick('slickPrev');
});
// Click next arrow master slider
$('.next-master-slider').click(function(){
$('.master-slider-look').slick('slickNext');
});

/*
// Init slider image look
jQuery('.slider-collections').slick({
dots: false,
infinite: true,
speed: 800,
fade: true,
cssEase: 'linear',
draggable: false,
swipe: false,
swipeToSlide: false,
touchMove: false,
adaptiveHeight: false,
arrows: false
});
*/

/*
// Click prev arrow collections slider
$('.prev-collections-slider').click(function(){
$('.slider-collections').slick('slickPrev');
})
// Click next arrow collections slider
$('.next-collections-slider').click(function(){
$('.slider-collections').slick('slickNext');
})
*/

// Collection handle from url
var collection_handle = getUrlVars()["look"] || null;
// console.log('collection_handle', collection_handle);
if (collection_handle != null) {
// Get item index slide
var item_slide = $('.master-slider-look div[data-collection="'+collection_handle+'"]');
var slick_slide_index = 0;
// var slick_slide_index_parent = 0;
if (item_slide.length > 0) {
slick_slide_index = item_slide.data('slick-index');
// slick_slide_index_parent = item_slide.parent().parent().parent().parent().parent().parent().attr('data-slick-index');
// console.log('slick_slide_index_parent', slick_slide_index_parent);
}
console.log('slide item index', slick_slide_index);

// console.log('slick slide parent', slick_slide_index_parent);
// Go to slide parent by index
setTimeout(function () {
$('.master-slider-look').slick("slickGoTo", parseInt(slick_slide_index));
}, 500);
// Go to slide child by index
// $('.slider-collections').slick("slickGoTo", parseInt(slick_slide_index));
}

function getUrlVars() {
var vars = {};
var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi,
function(m,key,value) {
vars[key] = value;
});
return vars;
}

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ad-shop-the-looks-fw23"]) return;
  try {
    
jQuery(function ($) {

// Init master slider
jQuery('.master-slider-look').slick({
dots: false,
infinite: true,
speed: 800,
fade: true,
cssEase: 'linear',
draggable: false,
swipe: false,
swipeToSlide: false,
touchMove: false,
adaptiveHeight: true,
arrows: false
});

// Click prev arrow master slider
$('.prev-master-slider').click(function(){
$('.master-slider-look').slick('slickPrev');
});
// Click next arrow master slider
$('.next-master-slider').click(function(){
$('.master-slider-look').slick('slickNext');
});

/*
// Init slider image look
jQuery('.slider-collections').slick({
dots: false,
infinite: true,
speed: 800,
fade: true,
cssEase: 'linear',
draggable: false,
swipe: false,
swipeToSlide: false,
touchMove: false,
adaptiveHeight: false,
arrows: false
});
*/

/*
// Click prev arrow collections slider
$('.prev-collections-slider').click(function(){
$('.slider-collections').slick('slickPrev');
})
// Click next arrow collections slider
$('.next-collections-slider').click(function(){
$('.slider-collections').slick('slickNext');
})
*/

// Collection handle from url
var collection_handle = getUrlVars()["look"] || null;
// console.log('collection_handle', collection_handle);
if (collection_handle != null) {
// Get item index slide
var item_slide = $('.master-slider-look div[data-collection="'+collection_handle+'"]');
var slick_slide_index = 0;
// var slick_slide_index_parent = 0;
if (item_slide.length > 0) {
slick_slide_index = item_slide.data('slick-index');
// slick_slide_index_parent = item_slide.parent().parent().parent().parent().parent().parent().attr('data-slick-index');
// console.log('slick_slide_index_parent', slick_slide_index_parent);
}
console.log('slide item index', slick_slide_index);

// console.log('slick slide parent', slick_slide_index_parent);
// Go to slide parent by index
setTimeout(function () {
$('.master-slider-look').slick("slickGoTo", parseInt(slick_slide_index));
}, 500);
// Go to slide child by index
// $('.slider-collections').slick("slickGoTo", parseInt(slick_slide_index));
}

function getUrlVars() {
var vars = {};
var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi,
function(m,key,value) {
vars[key] = value;
});
return vars;
}

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ad-shop-the-looks-ss"]) return;
  try {
    
jQuery(function ($) {

// Init master slider
jQuery('.master-slider-look').slick({
dots: false,
infinite: true,
speed: 800,
fade: true,
cssEase: 'linear',
draggable: false,
swipe: false,
swipeToSlide: false,
touchMove: false,
adaptiveHeight: true,
arrows: false
});

// Click prev arrow master slider
$('.prev-master-slider').click(function(){
$('.master-slider-look').slick('slickPrev');
});
// Click next arrow master slider
$('.next-master-slider').click(function(){
$('.master-slider-look').slick('slickNext');
});

/*
// Init slider image look
jQuery('.slider-collections').slick({
dots: false,
infinite: true,
speed: 800,
fade: true,
cssEase: 'linear',
draggable: false,
swipe: false,
swipeToSlide: false,
touchMove: false,
adaptiveHeight: false,
arrows: false
});
*/

/*
// Click prev arrow collections slider
$('.prev-collections-slider').click(function(){
$('.slider-collections').slick('slickPrev');
})
// Click next arrow collections slider
$('.next-collections-slider').click(function(){
$('.slider-collections').slick('slickNext');
})
*/

// Collection handle from url
var collection_handle = getUrlVars()["look"] || null;
// console.log('collection_handle', collection_handle);
if (collection_handle != null) {
// Get item index slide
var item_slide = $('.master-slider-look div[data-collection="'+collection_handle+'"]');
var slick_slide_index = 0;
// var slick_slide_index_parent = 0;
if (item_slide.length > 0) {
slick_slide_index = item_slide.data('slick-index');
// slick_slide_index_parent = item_slide.parent().parent().parent().parent().parent().parent().attr('data-slick-index');
// console.log('slick_slide_index_parent', slick_slide_index_parent);
}
console.log('slide item index', slick_slide_index);

// console.log('slick slide parent', slick_slide_index_parent);
// Go to slide parent by index
setTimeout(function () {
$('.master-slider-look').slick("slickGoTo", parseInt(slick_slide_index));
}, 500);
// Go to slide child by index
// $('.slider-collections').slick("slickGoTo", parseInt(slick_slide_index));
}

function getUrlVars() {
var vars = {};
var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi,
function(m,key,value) {
vars[key] = value;
});
return vars;
}

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ad-shop-the-looks"]) return;
  try {
    
jQuery(function ($) {

    // Init master slider
    jQuery('.master-slider-look').slick({
      dots: false,
      infinite: true,
      speed: 800,
      fade: true,
      cssEase: 'linear',
      draggable: false,
      swipe: false,
      swipeToSlide: false,
      touchMove: false,
      adaptiveHeight: true,
      arrows: false
    });

    // Click prev arrow master slider
    $('.prev-master-slider').click(function(){
    $('.master-slider-look').slick('slickPrev');
    });
    // Click next arrow master slider
    $('.next-master-slider').click(function(){
    $('.master-slider-look').slick('slickNext');
    });

    /*
    // Init slider image look
    jQuery('.slider-collections').slick({
        dots: false,
        infinite: true,
        speed: 800,
        fade: true,
        cssEase: 'linear',
        draggable: false,
        swipe: false,
        swipeToSlide: false,
        touchMove: false,
        adaptiveHeight: false,
        arrows: false
    });
    */

    /*
    // Click prev arrow collections slider
    $('.prev-collections-slider').click(function(){
      $('.slider-collections').slick('slickPrev');
    })
    // Click next arrow collections slider
    $('.next-collections-slider').click(function(){
      $('.slider-collections').slick('slickNext');
    })
    */

    // Collection handle from url
    var collection_handle = getUrlVars()["look"] || null;
    // console.log('collection_handle', collection_handle);
    if (collection_handle != null) {
      // Get item index slide
      var item_slide = $('.master-slider-look div[data-collection="'+collection_handle+'"]');
      var slick_slide_index = 0;
      // var slick_slide_index_parent = 0;
      if (item_slide.length > 0) {
        slick_slide_index = item_slide.data('slick-index');
        // slick_slide_index_parent = item_slide.parent().parent().parent().parent().parent().parent().attr('data-slick-index');
        // console.log('slick_slide_index_parent', slick_slide_index_parent);
      }
      console.log('slide item index', slick_slide_index);

      // console.log('slick slide parent', slick_slide_index_parent);
      // Go to slide parent by index
      setTimeout(function () {
        $('.master-slider-look').slick("slickGoTo", parseInt(slick_slide_index));
      }, 500);
      // Go to slide child by index
      // $('.slider-collections').slick("slickGoTo", parseInt(slick_slide_index));
    }

    function getUrlVars() {
      var vars = {};
      var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi,
      function(m,key,value) {
        vars[key] = value;
      });
      return vars;
    }

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ad-splash-page"]) return;
  try {
    

// Variables
var splashPageWrapper = $('#shopify-section-ad-splash-page'),
    splashpage = $('#ad-splash-page'),
    animationTime = splashpage.data('animation-time') * 1000,
    animationDelay = splashpage.data('animation-delay') * 1000,
    splash_screen_show = localStorage.getItem('splash_screen_show');

var body = $('body');


// Splash page gia visitata. Non mostrarla più.
if (splash_screen_show == 1 || body.hasClass('template-index')) {
    body.removeClass('stop-scroll-page');
} else {
    // Stop scrolling when splash is visible
    body.addClass('stop-scroll-page'); 
    splashPageWrapper.show();
    splashpage.show();
    // Remove splash page
    setTimeout(function () {        
        splashPageWrapper.fadeOut(animationTime);            
    }, animationDelay);
    setTimeout(function () {
        body.removeClass('stop-scroll-page');  
    }, (animationTime + animationDelay));
    
    localStorage.setItem('splash_screen_show', 1);
}





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flagshipstore-ad-looks-only-image"] && !window.DesignMode) return;
  try {
    

jQuery('.slider-images-look').slick({
    dots: false,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: 'linear'
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flagshipstore-flagship-store"]) return;
  try {
    

jQuery('.slider-images-look').slick({
    dots: false,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: 'linear'
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glassware-ad-looks-only-image"] && !window.DesignMode) return;
  try {
    

jQuery('.slider-images-look').slick({
    dots: false,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: 'linear'
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glassware-flagship-store"]) return;
  try {
    

jQuery('.slider-images-look').slick({
    dots: false,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: 'linear'
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homeware-ad-looks-only-image"] && !window.DesignMode) return;
  try {
    

jQuery('.slider-images-look').slick({
    dots: false,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: 'linear'
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homeware-flagship-store"]) return;
  try {
    

jQuery('.slider-images-look').slick({
    dots: false,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: 'linear'
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lighting-ad-looks-only-image"] && !window.DesignMode) return;
  try {
    

jQuery('.slider-images-look').slick({
    dots: false,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: 'linear'
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lighting-flagship-store"]) return;
  try {
    

jQuery('.slider-images-look').slick({
    dots: false,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: 'linear'
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["looks-slide-fw"] && !window.DesignMode) return;
  try {
    

jQuery('.slider-images-look').slick({
dots: false,
infinite: true,
speed: 500,
fade: true,
cssEase: 'linear'
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["looks-slide-fw23"] && !window.DesignMode) return;
  try {
    

jQuery('.slider-images-look').slick({
dots: false,
infinite: true,
speed: 500,
fade: true,
cssEase: 'linear'
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["looks-slide-ss"] && !window.DesignMode) return;
  try {
    

jQuery('.slider-images-look').slick({
dots: false,
infinite: true,
speed: 500,
fade: true,
cssEase: 'linear'
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["looks-slide-ss23"] && !window.DesignMode) return;
  try {
    

jQuery('.slider-images-look').slick({
dots: false,
infinite: true,
speed: 500,
fade: true,
cssEase: 'linear'
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tableware-ad-looks-only-image"] && !window.DesignMode) return;
  try {
    

jQuery('.slider-images-look').slick({
    dots: false,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: 'linear'
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tableware-flagship-store"]) return;
  try {
    

jQuery('.slider-images-look').slick({
    dots: false,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: 'linear'
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["various-ad-looks-only-image"] && !window.DesignMode) return;
  try {
    

jQuery('.slider-images-look').slick({
    dots: false,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: 'linear'
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["various-flagship-store"]) return;
  try {
    

jQuery('.slider-images-look').slick({
    dots: false,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: 'linear'
});


  } catch(e) { console.error(e); }
})();
})();
